import { takeEvery } from 'redux-saga'

import actions from 'actions'
import { commonScrollPage } from './common-sagas'

export function* watchCommonScrollPage() { // eslint-disable-line import/prefer-default-export
  yield* takeEvery(actions.COMMON_SCROLL_PAGE, commonScrollPage)
}



/** WEBPACK FOOTER **
 ** ./src/sagas/common/common-watchers.js
 **/